import React, { useCallback, useEffect, useState } from 'react';
import MultiSelectComponent from '../../../../component/MultiSelect';
import QrInput from '../QrInput';
import classes from './style.module.scss';
import { Icons } from '../../../../assets';
import ScrollableTable from '../../../../component/ScrollableTable';
import Exported from '../../../../service/endpoints';
import request from '../../../../service';
import { Toast } from '../../../../service/toast';
import NormalSelect from '../../../../component/NormalSelect';
import { Controller } from 'react-hook-form';
import { KG_BEARINGS, KG_BULK_FILTRATION, KG_FILTERS, KG_PROMO, KG_TRUCK_SOLUTIONS, KG_SKF, KG_GREASE } from '../../../../helpers';

const BulkQR = (props) => {
    const { errors, control, required, radioValue, filteredProduct, setFilteredProduct, formMethods } = props

    const INDIVIDUAL = 'Individual QR'
    const [completeProducts, setCompleteProducts] = useState([]);
    const [selectedOptions, setSelectedOptions] = useState([]);
    const [filterValue, setFilterValue] = useState('3');

    const [options, setOptions] = useState([{
        label: "",
        value: "",
    }])

    const optionselected = formMethods?.watch('selectedOptions')

    const statusOptions = [
        { label: KG_FILTERS, value: "3" },
        { label: KG_TRUCK_SOLUTIONS, value: "4" },
        { label: KG_BEARINGS, value: "1" },
        { label: KG_BULK_FILTRATION, value: "2" },
        { label: KG_PROMO, value: "5" },
        { label: KG_SKF, value: "6" },
        { label: KG_GREASE, value: "7" },
    ];

    const individualHeader = [
        { label: "Product Names" },
        { label: "Retailer Points" },
        { label: "Mechanic Points" },
        { label: "Quantity" },
        { label: "" }
    ]
    const bulkHeader = [
        { label: "Product Names" },
        { label: "Retailer Points" },
        { label: "Mechanic Points" },
        { label: "Carton quantity" },
        { label: "Order Quantity" },
        { label: "" }
    ]
    const productHeader = radioValue === INDIVIDUAL ? individualHeader : bulkHeader

    useEffect(() => {
        setSelectedOptions([])
        setFilteredProduct([])
        formMethods?.setValue('selectedOptions', [])
    }, [radioValue, filterValue])

    useEffect(() => {
        getProductOptions()
    }, [filterValue, radioValue])

    useEffect(() => {
        const products = completeProducts.filter((item) =>
            selectedOptions.map((option) => option.value).includes(item.reference_number)
        );

        let addedProduct = radioValue === INDIVIDUAL ? products : products.map((product, idx) =>
            [{ ...product, inputValue: product?.quantity }]
        )?.flat()
        setFilteredProduct(addedProduct)
    }, [selectedOptions])

    const getProductOptions = async () => {
        let url = `${Exported.Endpoints.getProductList}`
        let paramsObj = {
            type : radioValue == INDIVIDUAL ? 1 : 2
        }
        if (filterValue) {
            paramsObj['category'] = filterValue
        }
        await request({
            url: url,
            params: { ...paramsObj }
        }).then((res) => {
            if (res?.data?.status) {
                setOptions(
                    res?.data?.data?.map((it) => (
                        { label: it?.product_details?.reference_number, value: it?.product_details?.reference_number }
                    ))
                )
                setCompleteProducts(res?.data?.data?.map((x) => x?.product_details))
            }
        }).catch((err) => {
            console.log(err, "err")
            Toast({
                type: 'error',
                message: 'Unable to process the request!..'
            })
        })
    }

    const handleChange = (selected) => {
        setSelectedOptions(selected);
    };

    // const handleInputChange = useCallback((index) => (event) => {
    //     const newValue = event.target.value;
    //     setFilteredProduct((prevProducts) =>
    //         prevProducts.map((product, idx) =>
    //             idx === index ? { ...product, inputValue: newValue } : product
    //         )
    //     );
    // }, []);

    const handleStatus = async (value) => {
        setFilterValue(value)
    }

    const getLabelValue = (value) => {
        return statusOptions?.filter((x) => x?.value == value)?.at(0)?.label
    }

    const deleteQR = (itemName, index) => {
        formMethods?.setValue('selectedOptions', optionselected?.filter((x) => x?.value !== itemName))
        setSelectedOptions((prevSelect) => prevSelect?.filter((x) => x?.value !== itemName))
        setFilteredProduct((prevProduct) => prevProduct?.filter((x) => x?.reference_number !== itemName))

        let inputRecords = formMethods?.watch(`item`)
        formMethods?.setValue(`item`, inputRecords?.filter((x, idx) => idx !== index))
    }

    return (
        <div className='mb-8'>
            <div className='flex items-center justify-between'>
                <div className={classes.titleHeader}>General Info</div>

            </div>
            <div className='w-[100%] border-[#D9D9D9] bg-[#fff] rounded-md border-[1px] my-4'>
                <NormalSelect
                    className={`w-[100%] p-0`}
                    list={statusOptions}
                    value={filterValue ? getLabelValue(filterValue) : null}
                    handleChange={(e) => handleStatus(e)}
                    placeholder="Product Category"
                    label="Product Category"
                    borderTab
                />
            </div>
            <div className='mt-7'>
                <MultiSelectComponent
                    name="selectedOptions"
                    handleChange={handleChange}
                    control={control}
                    label="Product Names"
                    options={options}
                    error={errors.selectedOptions}
                    messages={{
                        required: "Selection is required",
                    }}
                    required={required}
                />
            </div>
            {filteredProduct?.length > 0 &&
                <div className=''>
                    <ScrollableTable
                        headerDetails={productHeader}
                        listLength={filteredProduct || []}
                        autoHeight
                    >
                        {
                            filteredProduct.map((item, index) => (
                                <div className='flex items-center rowTableData py-2 ' key={item?.reference_number}>
                                    <div className={`text-center w-[50%]`}>{item.reference_number}</div>
                                    <div className={`text-center w-[50%]`}>{item.retailer_points}</div>
                                    <div className={`text-center w-[50%]`}>{item.mechanic_points}</div>
                                    {radioValue !== INDIVIDUAL &&
                                        // <div className={`text-center w-[50%]`}>{item.quantity}
                                        <div className="text-center w-[50%]">
                                            <Controller
                                                key={index}
                                                name={`item[${index}].quantity`}
                                                control={control}
                                                defaultValue={1}
                                                rules={{
                                                    required: true,
                                                    validate: {
                                                        isNotZero: value => value > 0 || "Quantity must be greater than zero."
                                                    }
                                                }}
                                                render={({ field }) => (
                                                    <QrInput
                                                        {...field}
                                                        isBulk={radioValue == INDIVIDUAL ? false : true}
                                                        quantity={item.quantity}
                                                        defaultValue={1}
                                                        className={`${classes.productContent}`}
                                                        error={errors.item?.[index]?.quantity}
                                                        placeholder="Enter quantity"
                                                    />
                                                )}
                                            />
                                        </div>

                                        // </div>
                                    }
                                    <div className="text-center w-[50%]">
                                        <Controller
                                            key={index}
                                            name={`item[${index}].inputValue`}
                                            control={control}
                                            defaultValue={1}
                                            rules={{
                                                required: true,
                                                validate: {
                                                    isNotZero: value => value > 0 || "Value must be greater than zero.",
                                                    // isMultipleOfQuantity: value =>
                                                    //     radioValue !== INDIVIDUAL && item.quantity ? value % item.quantity === 0 || `Value must be a multiple of ${item.quantity}.` : null
                                                }
                                            }}
                                            render={({ field }) => (
                                                <QrInput
                                                    {...field}
                                                    isBulk={radioValue == INDIVIDUAL ? false : true}
                                                    quantity={item.quantity}
                                                    defaultValue={1}
                                                    className={`${classes.productContent}`}
                                                    error={errors.item?.[index]?.inputValue}
                                                    placeholder="Enter quantity"
                                                // handleInputChange={handleInputChange(index)}
                                                />
                                            )}
                                        />
                                    </div>
                                    <div className="text-center flex items-center justify-center w-[50%]">
                                        <img src={Icons.redCircle} className='w-[18px]' onClick={() => deleteQR(item.reference_number, index)} />
                                    </div>
                                </div>
                            ))
                        }
                    </ScrollableTable>
                </div>
            }
        </div>
    )
}

export default BulkQR